// Utils & misc
import cn from '../../../utils/cn';

// Styles
import styles from './DateRangePickerSidebar.module.css';

/**
 * DateRangePickerSidebar component - Sidebar for date range picker with predefined options
 * @param {object} props
 * @param {React.ReactNode} props.children - Sidebar content
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} DateRangePickerSidebar component
 */
function DateRangePickerSidebar({ children, className }) {
  return (
    <div className={cn([styles.sidebar, className])}>
      {children}
    </div>
  );
}

/**
 * DateRangePickerSidebarGroup component - Group wrapper for sidebar items
 * @param {object} props
 * @param {React.ReactNode} props.children - Group content
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} DateRangePickerSidebarGroup component
 */
export function DateRangePickerSidebarGroup({ children, className }) {
  return (
    <div className={cn([styles.group, className])}>
      {children}
    </div>
  );
}

export default DateRangePickerSidebar;
